var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editIcon_svg__clip0_1665_5089)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 14.625H1.125v1.125h15.75v-1.125zM14.287 5.063c.45-.45.45-1.125 0-1.575l-2.025-2.026a1.087 1.087 0 00-1.575 0L2.25 9.9v3.6h3.6l8.438-8.438zM11.476 2.25L13.5 4.275l-1.688 1.688-2.024-2.026 1.687-1.687zm-8.1 10.125V10.35L9 4.725l2.025 2.025L5.4 12.375H3.375z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editIcon_svg__clip0_1665_5089"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/editIcon.2e84a89f.svg";
export { MemoForwardRef as ReactComponent };